import { CSSProperties } from 'react'

import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const List: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  padding: 0,
}

export const CardWrapper: CSSProperties = {
  display: 'flex',
  flexShrink: 0,
  marginRight: 48,
  width: DEFAULT_NODE_WIDTH - sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2,
}
